import styled from 'styled-components';

import RichText from 'components/RichText';

import BREAKPOINTS from 'styles/breakpoints';
import FONTS from 'styles/fonts';
import COLORS from 'styles/colors';
import { Grid, GridInner, columns } from 'styles/grid';
import { weight, rem } from 'styles/typography';

const Container = styled.div`
  position: relative;
  padding: 60px 0 0;
  max-width: 1200px;
  margin: 0 auto;

  ${BREAKPOINTS.medium`
    padding: 110px 0 0;
  `}
`;

const Section = styled(Grid)`
  color: ${({ color }: { color: string }) => color};
  max-width: 1200px;
  padding: 0 40px 80px;

  ${BREAKPOINTS.medium`
  ${GridInner} {
        grid-template-rows : repeat(2, auto);
    }
    padding-bottom: 110px;
  `};
`;

const Title = styled(RichText)`
  ${columns(null, 12)}
  margin-bottom: 32px;

  h2 {
    font-size: ${rem(40)};
    line-height: ${rem(50)};
    font-weight: ${weight.semibold};
  }

  p {
    margin: 0;
  }

  ${BREAKPOINTS.medium`
     ${columns(null, 5)}
    margin-bottom: 0;
    max-width: 440px;
    
    h2 {
      font-size: ${rem(50)};
      line-height: ${rem(50)};
      font-weight: ${weight.semibold};
    }
  `}

  ${BREAKPOINTS.large`
    ${columns(2, 5)}
  `}
`;

const Content = styled(RichText)`
  ${columns(null, 12)}

  em {
    font-family: ${FONTS.wulkan};
    font-weight: ${weight.bold};
  }

  ${BREAKPOINTS.medium`
    ${columns(6, 6)}
    max-width: 400px;
  `}

  ${BREAKPOINTS.large`
    ${columns(7, 6)}
  `}
`;

const Description = ({ descriptionOne, descriptionTwo }) => {
  return (
    <Container>
      <Section color={COLORS.pink}>
        <Title html={descriptionOne?.html} />
        <Content
          html={descriptionTwo?.html}
          textIndent
          className="[&>p]:mb-4 last-child:mb-0"
        />
      </Section>
    </Container>
  );
};

export default Description;
